import {Injectable} from '@angular/core';
import 'rxjs/add/operator/toPromise';
import {Router} from '@angular/router';
import {CustomHttp} from '../shared/custom.http';
import {TitleRequest} from './model/titleRequest';


@Injectable()
export class TitleRequestService {
    private titleRequestUrl = '/tms/pcrequest';

    constructor(private router: Router, private http: CustomHttp) {
    }

    getAllRequests() {
        return this.http.get(this.titleRequestUrl, {body: ''});
    }

    addRequest(pcRequest: TitleRequest) {
        const url = `${this.titleRequestUrl}?content_id=${pcRequest.content_id}`;
        return this.http.post(url, pcRequest);
    }
}



// WEBPACK FOOTER //
// ./src/app/tms/titleRequest.service.ts